module.exports = __webpack_public_path__ + "0f5870c7e483b5bf3e8f1457c03eca45.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/winking-27.png
// module id = 2394
// module chunks = 0